import 'htmx.org';
import './session/sessiontimer';
import './rootcomponents/toggle';
import './rootcomponents/printable';
import './rootcomponents/character-counter';
import './rootcomponents/client-validation';
import './rootcomponents/file-upload';
import './rootcomponents/read-more';
import { initSession } from './session/sessionmain';
import { bindAutocompletes } from './rootcomponents/autocomplete';
import { updateSessionUI } from './session/sessionui';
import { dismissElement } from './rootcomponents/toggle';

document.addEventListener('DOMContentLoaded', () => {
    initSession()
        .then(() => {
            updateSessionUI();
            bindAutocompletes();
            bindEvents();
        });
});

function bindEvents() {
    window.addEventListener('resize', setSiteNavMenuState);
    document.querySelector<HTMLElement>('#footer-back-to-top')?.addEventListener('click', backToTopClicked);
    document.addEventListener('acclick', autocompleteClicked);
}

function setSiteNavMenuState() {
    const siteNavMenu = document.querySelector<HTMLElement>('#site-nav-menu');
    const siteNavOverlay = document.querySelector<HTMLElement>('#site-nav-overlay');

    if (siteNavMenu === null) {
        return;
    }

    if (window.innerWidth >= 768 && siteNavMenu.getAttribute('data-expanded') === "true") {
        dismissElement(siteNavMenu);
        if (siteNavOverlay !== null) {
            dismissElement(siteNavOverlay);
        }
    }
}

function backToTopClicked(evt: Event) {
    window.scrollTo(0, 0);
    document.querySelector<HTMLElement>('#skip-to-main')?.focus();
}

function autocompleteClicked() {
    sessionStorage.setItem('autocomplete', 'true');
}
